import React from 'react';

export default function ErrorTooltipHtml(props) {

    let className = props.className || "red-warning tooltip-trigger";


    let result = null;
    if (props.message)
        result = <div className={className}>!
            <span className="tooltip top red" dangerouslySetInnerHTML={{__html: props.message}} />
        </div>;
    return result;

}
